import React from 'react';
import { useSelector } from 'react-redux';

import moment from 'moment';
import 'moment/min/locales';

import IconButton from '@material-ui/core/IconButton';
import NotificationsIcon from '@material-ui/icons/Notifications';
import Drafts from '@material-ui/icons/Drafts';
import Fade from '@material-ui/core/Fade';
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import Button from '@material-ui/core/Button';
import Badge from '@material-ui/core/Badge';
import Empty from './img/undraw_empty_xct9.svg';


import axios from '../../../config/axiosInstance';

import { Container,
  PopperIcon,
  HistoryList,
  HeaderTitle,
  MessageContent,
  MessageEmpty,
  ShowMore,
  Scroll } from './styles';
import NotificationItem from '../../../components/NotificationEmployee';

function FormatDate(rawDate, stringFormat) {
  return moment(rawDate).format(stringFormat);
}
// notification
function Notification() {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [labelButton, setLabelButton] = React.useState('Mostrar Lidas');
  const [notifications, setNotifications] = React.useState({
    data: [],
    showAllRead: false,
  });
  const [notRead, setNotRead] = React.useState([]);
  const [showAllNot, setShowAllNot] = React.useState(false);

  const auth = useSelector(state => state.auth);
  const open = Boolean(anchorEl);
  const id = open ? 'transitions-popper' : undefined;


  React.useEffect(() => {
    async function fetchNotification(token) {
      const response = await axios.get('pushNotificationsMessage', {
        headers: { Authorization: `Bearer ${token}` },
      });
      const unreadItems = response.data.map((d, i) => ({
        key: `${d.id}`,
        text: d.message,
        title: d.sender,
        date: FormatDate(d.dtCreated, 'DD/MM'),
        isRead: d.isRead,
      }));
      setNotifications({
        ...notifications,
        data: unreadItems.filter(d => d.isRead === true),
      });
      setNotRead(unreadItems.filter(d => d.isRead === false));
    }
    fetchNotification(auth.token);
  }, [auth.token]);


  function handleClick(event) {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  }


  const showAllRead = () => {
    if (labelButton === 'Mostrar Lidas') {
      setShowAllNot(true);
      setLabelButton('Mostrar Não Lidas');
    } else {
      setShowAllNot(false);
      setLabelButton('Mostrar Lidas');
    }
  };

  const verifyRead = (item) => {
    const items = [...notRead];
    const items2 = items.filter(i => i !== item);
    setNotRead(items2);
  };

  const markAllRead = () => {
    const allNotRead = notRead.map(n => n.key);

    axios.post('pushNotificationsMessage/markRead', { idsMessages: allNotRead }, {
      headers: { Authorization: `Bearer ${auth.token}` },

    });
  };

  function showNotifications() {
    if (showAllNot === true) {
      return (notifications.data.map(n => (
        <React.Fragment key={n.key}>
          <Divider />
          <NotificationItem notification={n} token={auth.token} isRead={false} />
        </React.Fragment>


      )));
    } else if (notRead.length === 0) {
      return (<div style={{ textAlign: 'center', marginTop: 24, marginBottom: 24 }}>
        <img width={220} height={173} src={Empty} alt="vazio" />
        <div style={{ marginBottom: 25 }}>
          <MessageEmpty> Nada Novo Aqui</MessageEmpty>
          <MessageContent>As novas notificações aparecerão aqui </MessageContent>
        </div>
      </div>);
    }

    return (
      <div>
        { notRead && notRead.map(n => (
          <React.Fragment key={n.key}>
            <Divider />
            <NotificationItem notification={n} token={auth.token} isRead verifyRead={verifyRead} />
          </React.Fragment>
          ))}
      </div>

    );
  }

  return (
    <Container>
      <IconButton color="inherit" onClick={handleClick} style={{ margin: 20 }}>
        <Badge badgeContent={notRead.length} color="error">
          <NotificationsIcon />
        </Badge>
      </IconButton>
      <PopperIcon
        id={id}
        open={open}
        anchorEl={anchorEl}
        transition
        placement="bottom-end"
      >
        {({ TransitionProps }) => (
          <Fade {...TransitionProps} timeout={350}>
            <HistoryList elevation={2} >
              <List aria-label="lista de notificações">
                <HeaderTitle >
                  Notificações { labelButton === 'Mostrar Lidas' && <IconButton disabled={notRead.length === 0} onClick={markAllRead} >
                    <Drafts fontSize="small" style={notRead.length === 0 ? { color: '#C4C4C4' } : { color: '#000' }} />
                                                                    </IconButton> }
                </HeaderTitle>
                <Scroll options={{ wheelPropagation: false }}>
                  { showNotifications() }
                </Scroll>

                <Divider />
                <ShowMore>
                  <Button color="primary" onClick={showAllRead}>{labelButton}</Button>
                </ShowMore>
              </List>
              {/* */}
            </HistoryList>
          </Fade>
            )}
      </PopperIcon>
    </Container>
  );
}

export default Notification;
